import React, { useState, useEffect } from 'react'
import P_samall_card from './P_samall_card'
import { productsData } from '../../constants'
import { useTranslation } from 'react-i18next'

const P_related_products = ({ id }) => {
    const [cardData, setcardData] = useState([])
    
    useEffect(() => {
        setcardData(productsData.filter(card => card.id !== id))
    }, [id])
    const {t} =useTranslation()
    return (
        <div className='flex flex-col items-start max-w-[25rem] gap-4'>
            <h6 className="text-light-titke dark:text-dark-title h5">{t("Related Products")}</h6>
            {
                cardData.map((item) => (
                    <P_samall_card key={item.id} card={item} />
                ))
            }
        </div>
    )
}

export default P_related_products